import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NotificationEntity } from '../../models';

@Component({
  selector: 'app-notification-item',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ButtonModule, TooltipModule],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  readonly notification = input.required<NotificationEntity>();
  readonly compact = input<boolean>(false);

  readonly read = output<NotificationEntity>();
  readonly clicked = output<NotificationEntity>();

  readonly itemClass = computed(() => {
    const n = this.notification();
    return [
      'notification-item',
      n.isUnread ? 'notification-item--unread' : 'notification-item--read',
      `notification-item--${n.severity}`,
    ].join(' ');
  });

  onClick(): void {
    this.clicked.emit(this.notification());
  }

  onMarkRead(event: Event): void {
    event.stopPropagation();
    this.read.emit(this.notification());
  }
}
